import { render, staticRenderFns } from "./AppleLoginButton.vue?vue&type=template&id=4edd3bb6&scoped=true&"
import script from "./AppleLoginButton.vue?vue&type=script&lang=ts&"
export * from "./AppleLoginButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppleLoginButton.vue?vue&type=style&index=0&id=4edd3bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd3bb6",
  null
  
)

export default component.exports